var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1018 3.49967C12.6526 3.70384 12.1684 3.83801 11.6668 3.90217C12.1801 3.59301 12.5768 3.10301 12.7634 2.51384C12.2793 2.80551 11.7426 3.00967 11.1768 3.12634C10.7159 2.62467 10.0684 2.33301 9.33344 2.33301C7.9626 2.33301 6.8426 3.45301 6.8426 4.83551C6.8426 5.03384 6.86594 5.22634 6.90677 5.40717C4.8301 5.30217 2.98094 4.30467 1.7501 2.79384C1.53427 3.16134 1.41177 3.59301 1.41177 4.04801C1.41177 4.91717 1.84927 5.68717 2.52594 6.12467C2.11177 6.12467 1.72677 6.00801 1.38844 5.83301C1.38844 5.83301 1.38844 5.83301 1.38844 5.85051C1.38844 7.06384 2.25177 8.07884 3.3951 8.30634C3.1851 8.36467 2.96344 8.39384 2.73594 8.39384C2.57844 8.39384 2.42094 8.37634 2.26927 8.34717C2.58427 9.33301 3.5001 10.068 4.6026 10.0855C3.75094 10.7622 2.67177 11.1588 1.49344 11.1588C1.2951 11.1588 1.09677 11.1472 0.898438 11.1238C2.00677 11.8355 3.3251 12.2497 4.73677 12.2497C9.33344 12.2497 11.8593 8.43467 11.8593 5.12717C11.8593 5.01634 11.8593 4.91134 11.8534 4.80051C12.3434 4.45051 12.7634 4.00717 13.1018 3.49967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4d5ec5ea1169d325ad7b56e764aa0b50.svg";
export { ForwardRef as ReactComponent };